import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { business } from "../data/mock";

const links = [
  { to: "/", label: "Home" },
  { to: "/photography", label: "Photography" },
  { to: "/drone", label: "Drone Work" },
  { to: "/fpv", label: "FPV Covers" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md shadow-sm py-3" : "bg-transparent py-5"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-sky-500 to-sky-600 text-white font-heading font-bold text-lg shadow-lg shadow-sky-500/30 group-hover:scale-105 transition-transform">
            F
          </span>
          <span className="font-heading font-bold text-lg text-slate-900 leading-none">
            Fred Mustica<span className="block text-[11px] font-medium text-slate-500">Home Technical Services</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `relative px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${
                  isActive ? "text-sky-600" : "text-slate-700 hover:text-sky-600"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={business.phoneHref}
            className="ml-3 inline-flex items-center gap-2 rounded-full bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-5 py-2.5 shadow-lg shadow-orange-500/30 transition-all hover:-translate-y-0.5"
          >
            <Phone size={16} /> {business.phone}
          </a>
        </div>

        <button
          className="lg:hidden p-2 text-slate-800"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Menu size={26} />
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setOpen(false)}
            />
            <motion.div
              className="fixed top-0 right-0 bottom-0 w-72 bg-white z-50 p-6 flex flex-col"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", ease: [0.22, 1, 0.36, 1], duration: 0.35 }}
            >
              <div className="flex justify-end">
                <button onClick={() => setOpen(false)} aria-label="Close menu" className="p-2 text-slate-700">
                  <X size={26} />
                </button>
              </div>
              <div className="flex flex-col gap-1 mt-4">
                {links.map((l) => (
                  <NavLink
                    key={l.to}
                    to={l.to}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `px-4 py-3 rounded-xl text-base font-semibold ${
                        isActive ? "bg-sky-50 text-sky-600" : "text-slate-700 hover:bg-slate-50"
                      }`
                    }
                  >
                    {l.label}
                  </NavLink>
                ))}
              </div>
              <a
                href={business.phoneHref}
                className="mt-auto inline-flex items-center justify-center gap-2 rounded-full bg-orange-500 text-white font-semibold px-5 py-3 shadow-lg shadow-orange-500/30"
              >
                <Phone size={18} /> Call {business.phone}
              </a>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </header>
  );
}
